import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const Step2PreSchool = props => {
  if (props.currentStep !== 2) {
    return null;
  }

  return (
    <>
      <FormGroup>
       
      <br/>
      <Label for="username">Type</Label>  <br/>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check1" name="searchkey" value="17" onChange={props.handleChange} />
      <label class="form-check-label">Montesorri</label>
      </div>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="16" onChange={props.handleChange} />
      <label class="form-check-label">Kindergarten</label>
      </div>
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="18" onChange={props.handleChange} />
      <label class="form-check-label">Play Group</label>
      </div> 
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="20" onChange={props.handleChange} />
      <label class="form-check-label">Special Needs</label>
      </div> 
      <div class="form-check form-check-inline">
      <input class="form-check-input" type="checkbox" id="check2" name="searchkey" value="175" onChange={props.handleChange} />
      <label class="form-check-label">Day care or Creche</label>
      </div> 
      
      </FormGroup>
    </>
  );
};

export default Step2PreSchool;
